import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getSingleQuickLink = async (
  id: number,
  params?: { is_multiple?: boolean }
) => {
  return await axiosPrivate.get(`/dashboard/api/v1/payment-links/${id}`, {
    params: params?.is_multiple ? { is_multiple: true } : undefined,
  });
};

export const getQuickLinks = async ({
  currentPage,
  pageSize,
  isLive,
  params = {},
}: {
  currentPage: number;
  pageSize: number;
  isLive: boolean;
  params: Record<string, string | number | boolean>;
}) => {
  const formattedPhoneNumber = params.phone_number ? `+${params.phone_number}` : undefined;

  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    ...params,
    ...(formattedPhoneNumber && { phone_number: formattedPhoneNumber }),
  };

  return await axiosPrivate.get('/dashboard/api/v1/payment-links', {
    params: queryParams,
  });

};

export const cancelQuickLink = async (paymentLinkId: number) => {
  return axiosPrivate.post('/dashboard/api/v1/payment-links/cancel', {
    payment_link_id: paymentLinkId,
  });
};

export const shareQuickLink = async (paymentLinkId: number, contacts: string[]) => {
  const formData = new FormData();
  
  contacts.forEach((contact) => {
    formData.append('share_with', contact);
  });
  
  formData.append('multiple_link_id', paymentLinkId.toString());
  
  return axiosPrivate.post('/dashboard/api/v1/payment-links/share-link', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};